export default "__VITE_ASSET__uikHiyH7__"